///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';

export class GtthRefreshTopologyCommand extends GtthAbstractCommand {
    private isInitRefreshCall: boolean;
    private centerMapAfterRefresh: boolean;
    private invalidateBackendCache: boolean;

    getCommandName(): string {
        return 'GtthRefreshTopologyCommand';
    }

    create(isInit: boolean, centerMapAfterRefresh = false): this {
        this.isInitRefreshCall = isInit;
        this.centerMapAfterRefresh = centerMapAfterRefresh;
        this.invalidateBackendCache = false;
        return this;
    }

    createWithCacheInvalidation(): this {
        this.isInitRefreshCall = false;
        this.centerMapAfterRefresh = false;
        this.invalidateBackendCache = true;
        return this;
    }

    doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        const activity = this.createActivityDTO(false);
        activity.forceClearCache = this.invalidateBackendCache;
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        const geoJson = activityDto.logicalTopology;

        if (!this.isInitRefreshCall && this.historyService.logicalTopology) {
            this.historyService.logicalTopology.clearTopologyEntities();
            this.historyService.projectInfoViewService.clearNodesToConnectCount();
            this.historyService.polygonsService.hidePolygons();
        }

        this.historyService.logicalTopology.parseGeoJsonMainConfig(geoJson, this.historyService);

        this.historyService.logicalTopology.parseGeoJsonEntities(activityDto.nodes, activityDto.links, this.historyService);

        this.historyService.polygonsService.parseStoredPolygons(geoJson.crs.properties.storedPolygons, this.historyService);

        this.historyService.polygonsService.toggleStoredPolygons();

        if (this.centerMapAfterRefresh && this.historyService.logicalTopology.getTerminalStationsCount() > 0) {
            this.historyService.logicalTopology.getMapBounds().then((newBounds) => {
                this.historyService.mapFitBounds(newBounds);
            });
        }

        // for BOM config projects always show topology in design mode
        if (this.historyService.projectStateService.isBomConfigProject()) {
            this.historyService.logicalTopology.isShowPlanningMode = true;
        }

        this.historyService.logicalTopology
            .setShowPlanningMode(this.historyService, this.historyService.logicalTopology.isShowPlanningMode, false)
            .then(() => {
                if (this.commandResolve) {
                    this.commandResolve(true);
                }

                if (!this.isInitRefreshCall) {
                    this.historyService.eventManager.broadcast({
                        name: 'togglePreloaderModal',
                        eventObject: GtthPreloaderModalEvent.hide()
                    });
                }
            });
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
